import React, {Component} from 'react';
import {View, Image, TouchableOpacity, I18nManager} from 'react-native';
import {moderateScale} from "../../tools/Scaling"
import Colors from "../../tools/Colors";

import HMIcon from "../HMIcon";
import HMTextView from "../HMTextView";
import {Tools} from "../../tools/Tools";
import {SeekBar} from "../seekbar";

let container = null;
export default class HMVoicePlayer extends Component {
    constructor(props) {
        super(props);
        container = this;

        let {duration} = props;
        let d = duration && duration != "null" && duration != null && duration != "undefined" ? duration : 0;

        this.state = {
            isPlaying: null,
            duration: d,
            currentTime: 0,
            percentTime: 0,
        }
    }

    componentWillReceiveProps(props) {


        //    this.props.index !== this.props.indexSelect && this.audioRef ? this.audioRef.pause() : null
        // if (sound)
        //     sound.pause();


    }

    playPreview() {
        // this.setState({
        //     currentTime: 0,
        //     percentTime: 0,
        // })
        if (!this.state.isPlaying) {
            if (this.props.audioRefExtra) {
                this.props.audioRefExtra.pause();
            }
            this.setState({isPlaying: true});
            this.audioRef.play();
        } else {
            this.setState({isPlaying: false});
            this.audioRef.pause();
        }
    }

    onPlay(second) {
        //  console.log("onPlay", second)
        // Store song current time in the Store on each one second
        //   store.dispatch({ type: 'SET_CURRENT_SECOND', second });
    }

    // onRewind(seconds) {
    //     console.log("onRewind", seconds)
    //
    //     // Rewind song current time
    //     // store.dispatch({ type: 'REWIND_CURRENT_SECOND', seconds });
    // }
    //
    // onSeek(seconds) {
    //     console.log("onSeek", seconds)
    //
    //     // Seek song current time
    //     // store.dispatch({ type: 'SEEK_CURRENT_SECOND', seconds });
    // }

    getCurrDuration = (e) => {
        // const percent = (
        //     (e.currentTarget.currentTime / e.currentTarget.duration) *
        //     100
        // );

        const time = e.currentTarget.currentTime;
        //console.log("time", time, percent)
        this.setState({
            currentTime: time,
            //  percentTime: percent,
        })
        // setPercentage(+percent);
        // setCurrentTime(time.toFixed(2));
    };

    render() {
        const {text, path, onPress, index, indexSelect, item, SeekBarCheck, style, styleTime, styleIcon, durationDynamic} = this.props;
        //  let durationVoice = duration && duration != "null" && duration != null && duration != "undefined" ? duration : 0
        const {isPlaying, duration} = this.state;
        let durationFinal=durationDynamic?durationDynamic:duration;

        return <TouchableOpacity
            style={style ? style : {
                width: moderateScale(240),
                height: moderateScale(40),
                margin: moderateScale(4),
                //  backgroundColor:"#00eee8"
            }}
            activeOpacity={1}
        >
            <audio
                ref={(input) => {
                    this.audioRef = input
                }}
                controls
                style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: .009
                }}
                src={path}
                onEnded={() => {

                    this.setState(
                        {
                            isPlaying: false,
                            currentTime: duration,
                        },
                        () => {
                            // this._pause()

                        }
                    )
                }}
                onPlay={this.onPlay}
                // onRewind={this.onRewind}
                // onSeek={this.onSeek}
                onTimeUpdate={this.getCurrDuration}
                onLoadedData={(e) => {
                    let time = e.currentTarget.duration;
                    //  console.log("time@",time)
                    if (durationFinal) {
                    }
                    else if (time == "Infinity") {

                        Tools.getDuration(path, function (duration) {
                            time = duration
                            container.setState({
                                    duration: time
                                },
                                () => {
                                    // console.log("time@1",time)

                                }
                            )
                        });
                    }
                    else
                        this.setState({
                            duration: time
                        })
                }}
            />

            <View
                style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginHorizontal: moderateScale(8)
                }}>

                <HMTextView

                    type={"bold"}

                    style={[{
                        fontSize: moderateScale(12),
                        color: "#814646",
                        marginEnd: moderateScale(10),
                        // marginTop: moderateScale(10)
                    }, styleTime ? styleTime : {}]}
                    //  text={"0:01"}
                    //text={Tools.getAudioTimeStringMin(this.state.duration)}
                    text={durationFinal ? Tools.getAudioTimeStringMin(parseFloat(durationFinal)) : "00:00"}
                />
                {
                    SeekBarCheck ?

                        <View style={{width: moderateScale(170)}}>

                            <SeekBar
                                animateTransitions
                                maximumTrackTintColor="#d3d3d3"
                                // maximumValue={this.state.duration}
                                maximumValue={duration ? parseFloat(duration) : 0}
                                minimumTrackTintColor="#1fb28a"
                                minimumValue={0}
                                value={this.state.currentTime}
                                step={1}
                                thumbTintColor="#1a9274"
                                onSlidingComplete={(e) => {
                                    if ((e && e[0] && this.audioRef)) {
                                        this.setState({currentTime: e[0]},
                                            () => {
                                                this.audioRef.currentTime = e[0]
                                            }
                                        )

                                    }
                                }}
                               //containerStyle={{transform: [{scaleX: -1}]}}
                                disabled
                            />

                        </View>
                        : null
                }

                {/*

                <HMIcon
                    type={"Feather"}
                    name={"align-center"}
                    style={{
                        // width: moderateScale(10),
                        // height: moderateScale(40),
                        textAlign: 'center',
                        margin: -moderateScale(10),
                        padding: -moderateScale(10),
                        //alignSelf: 'flex-end',
                        color: Colors.blackLight,
                        // width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(26),
                        transform: [{rotate: '90deg'}],
                    }}
                    //size={40}
                    // style={{
                    //     flex: 0,
                    //     width: moderateScale(20),
                    //     height: moderateScale(20),
                    //     alignSelf: 'center',
                    //     alignItems: 'center',
                    //     justifyContent: 'center',
                    //     textAlign: 'center',
                    //     backgroundColor: '#e24c4b',
                    //     color: 'white',
                    //     margin: -6,
                    //     padding: -6,
                    //
                    //     fontSize: moderateScale(20),
                    //     transform: [{ rotate: '90deg'}],
                    // }}
                />

                <HMIcon
                    type={"Feather"}
                    name={"align-center"}
                    style={{
                        // width: moderateScale(10),
                        // height: moderateScale(40),
                        textAlign: 'center',
                        marginEnd: -moderateScale(10),
                        paddingEnd: -moderateScale(10),
                        //alignSelf: 'flex-end',
                        color: Colors.blackLight,
                        // width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(26),
                        transform: [{rotate: '270deg'}],
                    }}/>

                <HMIcon
                    type={"Feather"}
                    name={"align-center"}
                    style={{
                        // width: moderateScale(10),
                        // height: moderateScale(40),
                        textAlign: 'center',
                        marginEnd: -moderateScale(10),
                        paddingEnd: -moderateScale(10),
                        //alignSelf: 'flex-end',
                        color: Colors.blackLight,
                        // width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(26),
                        transform: [{rotate: '90deg'}],
                    }}/>

                <HMIcon
                    type={"Feather"}
                    name={"align-center"}
                    style={{
                        // width: moderateScale(10),
                        // height: moderateScale(40),
                        textAlign: 'center',
                        marginEnd: -moderateScale(10),
                        paddingEnd: -moderateScale(10),
                        //alignSelf: 'flex-end',
                        color: Colors.blackLight,
                        // width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(26),
                        transform: [{rotate: '270deg'}],
                    }}/>

                <HMIcon
                    type={"Feather"}
                    name={"align-center"}
                    style={{
                        //  width: moderateScale(40),
                        // height: moderateScale(40),
                        textAlign: 'center',
                        //alignSelf: 'flex-end',
                        color: Colors.blackLight,
                        // width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(26),
                        transform: [{rotate: '90deg'}],
                    }}/>

*/}

                <HMIcon
                    onPress={() => {
                        this.playPreview();
                        onPress ? onPress(() => {
                        }, this.audioRef) : null

                        // this.setState({
                        //     visibleModal: "selectVideo",
                        //     //   pathVideo: checkAudio,
                        //     sliderList: [item],
                        //
                        //     slider1ActiveSlide: 0,
                        //     // visibleModal: "selectaudio",
                        //     // pathAudio: checkAudio,
                        // })
                    }}
                    // name={!isPlaying ? "play" : "pause"}
                    name={!isPlaying || (index !== indexSelect) ? "play" : ("pause")}

                    style={[{
                        //  width: moderateScale(40),
                        // height: moderateScale(40),
                        textAlign: 'center',
                        //alignSelf: 'flex-end',
                        color: Colors.blue,
                        // width: moderateScale(32),
                        // height: moderateScale(32),
                        fontSize: moderateScale(26),

                    }, styleIcon ? styleIcon : {}]}/>
            </View>


            {/*       <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            type={"MaterialCommunityIcons"}
                                            name={"account-tie-voice"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>*/}
        </TouchableOpacity>

    }
}
